import { api, authHeader } from "../configs/axiosConfigs";

const BASE = "api/customer/assisted-registration";

const normalize = (res, fallbackMessage) => {
  const isSuccess = res?.isSuccess ?? res?.IsSuccess;
  if (isSuccess === false) {
    return {
      isSuccess: false,
      data: null,
      message: res?.message ?? res?.Message ?? fallbackMessage,
      statusCode: res?.statusCode ?? res?.StatusCode,
    };
  }
  return {
    isSuccess: true,
    data: res?.data ?? res?.Data ?? null,
    message: res?.message ?? res?.Message,
  };
};

const CustomerAssistedRegistrationApi = {
  getActive: async () => {
    const response = await api.request({
      url: `${BASE}/active`,
      method: "GET",
      headers: authHeader(),
    });
    return normalize(response.data, "دریافت پرونده ناموفق بود.");
  },

  getDetail: async (leadId) => {
    const response = await api.request({
      url: `${BASE}/${leadId}`,
      method: "GET",
      headers: authHeader(),
    });
    return normalize(response.data, "دریافت پرونده ناموفق بود.");
  },

  saveCorrection: async (leadId, correction) => {
    const response = await api.request({
      url: `${BASE}/${leadId}/correction`,
      method: "PUT",
      data: correction,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return normalize(response.data, "ذخیره اصلاحات ناموفق بود.");
  },

  resubmit: async (leadId) => {
    const response = await api.request({
      url: `${BASE}/${leadId}/resubmit`,
      method: "POST",
      headers: authHeader(),
    });
    return normalize(response.data, "ارسال مجدد ناموفق بود.");
  },

  parseLocation: async (locationInput) => {
    const response = await api.request({
      url: `${BASE}/parse-location`,
      method: "POST",
      data: { locationInput },
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return normalize(response.data, "پردازش موقعیت ناموفق بود.");
  },
};

export default CustomerAssistedRegistrationApi;
